import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { AsyncAiDynamicPromptsResult } from "./types";

export const isAsyncAiDynamicPromptsResult = objectOf<AsyncAiDynamicPromptsResult>({
  status: number,
  result: objectOf<{ prompts: string[] }>({
    prompts: arrayOf(string),
  }),
  message: maybe(string),
});
